import { render } from "./PlayerRatingList.vue?vue&type=template&id=0c169764&scoped=true"
import script from "./PlayerRatingList.vue?vue&type=script&lang=js"
export * from "./PlayerRatingList.vue?vue&type=script&lang=js"

import "./PlayerRatingList.vue?vue&type=style&index=0&id=0c169764&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c169764"]])

export default __exports__